<template>
  <IconMdiYahoo />
</template>
